/**
 * American Fusion Wheels — Vehicle Year/Make/Model Finder
 * Uses NHTSA vPIC API (free, no key required) for model lookups
 */
(function () {
  'use strict';

  var NHTSA_BASE = 'https://vpic.nhtsa.dot.gov/api/vehicles';

  var COMMON_MAKES = [
    'Acura', 'Alfa Romeo', 'Audi', 'BMW', 'Buick', 'Cadillac',
    'Chevrolet', 'Chrysler', 'Dodge', 'FIAT', 'Ford', 'Genesis',
    'GMC', 'Honda', 'Hyundai', 'INFINITI', 'Jaguar', 'Jeep',
    'Kia', 'Land Rover', 'Lexus', 'Lincoln', 'Maserati', 'Mazda',
    'Mercedes-Benz', 'MINI', 'Mitsubishi', 'Nissan', 'Porsche',
    'Ram', 'Rivian', 'Subaru', 'Tesla', 'Toyota', 'Volkswagen',
    'Volvo'
  ];

  var TRUCK_MAKES = [
    'Chevrolet', 'Dodge', 'Ford', 'GMC', 'Jeep', 'Nissan',
    'Ram', 'Toyota'
  ];

  /* Fallback models for older vehicles when NHTSA API returns empty.
     Covers classic/vintage models by make (roughly pre-1992). */
  var CLASSIC_MODELS = {
    'Acura': ['Integra', 'Legend', 'NSX', 'Vigor'],
    'Alfa Romeo': ['Spider', 'GTV', 'Milano', 'Graduate', '164'],
    'Audi': ['80', '90', '100', '200', '4000', '5000', 'Coupe', 'Quattro'],
    'BMW': ['2002', '3 Series', '318i', '325i', '325e', '5 Series', '525i', '535i', '6 Series', '635CSi', '7 Series', '735i', '750iL', 'M3', 'M5', 'M6', 'Z1'],
    'Buick': ['Century', 'Electra', 'GS', 'GSX', 'Grand National', 'LeSabre', 'Park Avenue', 'Regal', 'Riviera', 'Roadmaster', 'Skylark', 'Special', 'Wildcat'],
    'Cadillac': ['Brougham', 'Coupe de Ville', 'DeVille', 'Eldorado', 'Fleetwood', 'Sedan de Ville', 'Seville', 'Series 62', 'Allante'],
    'Chevrolet': ['Apache', 'Astro', 'Bel Air', 'Blazer', 'C10', 'C20', 'C30', 'C/K 1500', 'C/K 2500', 'C/K 3500', 'Camaro', 'Caprice', 'Cavalier', 'Chevelle', 'Cheyenne', 'Citation', 'Colorado', 'Corsica', 'Corvette', 'El Camino', 'Fleetline', 'Impala', 'K5 Blazer', 'K10', 'K20', 'Lumina', 'Malibu', 'Monte Carlo', 'Nova', 'S-10', 'S-10 Blazer', 'Silverado', 'Suburban', 'Stepside', 'Styleline'],
    'Chrysler': ['300', '300C', 'Cordoba', 'Fifth Avenue', 'Imperial', 'LeBaron', 'New Yorker', 'Newport', 'Saratoga', 'Town & Country', 'Valiant', 'Windsor'],
    'Dodge': ['Challenger', 'Charger', 'Coronet', 'D100', 'D150', 'D250', 'Dakota', 'Dart', 'Daytona', 'Demon', 'Diplomat', 'Duster', 'Lancer', 'Monaco', 'Polara', 'Power Wagon', 'Ram', 'Ramcharger', 'Shadow', 'Spirit', 'Stealth', 'Super Bee', 'Viper', 'W100', 'W150', 'W250'],
    'FIAT': ['124 Spider', '500', '850 Spider', 'X1/9'],
    'Ford': ['Bronco', 'Bronco II', 'Country Squire', 'Courier', 'Crown Victoria', 'Custom', 'Econoline', 'Escort', 'Expedition', 'Explorer', 'F-100', 'F-150', 'F-250', 'F-350', 'Fairlane', 'Falcon', 'Festiva', 'Galaxie', 'Gran Torino', 'LTD', 'Maverick', 'Model A', 'Model T', 'Mustang', 'Pinto', 'Probe', 'Ranchero', 'Ranger', 'Taurus', 'Tempo', 'Thunderbird', 'Torino'],
    'Genesis': [],
    'GMC': ['C1500', 'C2500', 'C3500', 'Caballero', 'Jimmy', 'K1500', 'K2500', 'K3500', 'Rally', 'S-15', 'S-15 Jimmy', 'Sierra', 'Sonoma', 'Sprint', 'Suburban', 'Syclone', 'Typhoon', 'Vandura', 'Yukon'],
    'Honda': ['Accord', 'Civic', 'CRX', 'Prelude', 'S2000'],
    'Hyundai': ['Excel', 'Scoupe', 'Sonata'],
    'INFINITI': ['G20', 'M30', 'Q45'],
    'Jaguar': ['E-Type', 'Mark II', 'XJ6', 'XJ12', 'XJS', 'XK120', 'XK140', 'XK150'],
    'Jeep': ['Cherokee', 'CJ-2A', 'CJ-3A', 'CJ-3B', 'CJ-5', 'CJ-6', 'CJ-7', 'CJ-8 Scrambler', 'Comanche', 'Commander', 'Grand Cherokee', 'Grand Wagoneer', 'Gladiator', 'J-10', 'J-20', 'Wagoneer', 'Willys', 'Wrangler', 'Wrangler YJ'],
    'Kia': ['Sephia'],
    'Land Rover': ['Defender', 'Discovery', 'Range Rover', 'Range Rover Classic', 'Series I', 'Series II', 'Series III'],
    'Lexus': ['ES 250', 'LS 400', 'SC 300', 'SC 400'],
    'Lincoln': ['Continental', 'Mark III', 'Mark IV', 'Mark V', 'Mark VI', 'Mark VII', 'Town Car'],
    'Maserati': ['Biturbo', 'Ghibli', 'Merak', 'Quattroporte', 'Spyder'],
    'Mazda': ['323', '626', 'B2000', 'B2200', 'B2600', 'GLC', 'Miata', 'MPV', 'MX-6', 'RX-3', 'RX-4', 'RX-7'],
    'Mercedes-Benz': ['190E', '190SL', '230SL', '240D', '250', '280SE', '280SL', '300D', '300E', '300SL', '380SL', '420SEL', '450SL', '500SEC', '500SEL', '560SEL', '560SL', 'E-Class', 'S-Class', 'SL-Class'],
    'MINI': [],
    'Mitsubishi': ['3000GT', 'Eclipse', 'Galant', 'Mighty Max', 'Montero', 'Starion'],
    'Nissan': ['200SX', '240SX', '240Z', '260Z', '280Z', '280ZX', '300ZX', '720', 'D21', 'Hardbody', 'Maxima', 'Pathfinder', 'Pulsar', 'Sentra', 'Stanza'],
    'Porsche': ['356', '911', '912', '914', '924', '928', '930 Turbo', '944', '959', '964', '968'],
    'Ram': [],
    'Rivian': [],
    'Subaru': ['Brat', 'GL', 'Justy', 'Legacy', 'Loyale', 'SVX', 'XT'],
    'Tesla': [],
    'Toyota': ['4Runner', 'Camry', 'Celica', 'Corolla', 'Corona', 'Cressida', 'FJ40', 'FJ60', 'FJ62', 'Hilux', 'Land Cruiser', 'MR2', 'Pickup', 'Previa', 'Starlet', 'Supra', 'T100', 'Tacoma', 'Tercel'],
    'Volkswagen': ['Beetle', 'Bus', 'Cabriolet', 'Corrado', 'Fox', 'Golf', 'GTI', 'Jetta', 'Karmann Ghia', 'Passat', 'Rabbit', 'Scirocco', 'Thing', 'Vanagon'],
    'Volvo': ['122', '140', '164', '240', '244', '245', '740', '760', '780', '850', '940', '960', 'P1800']
  };

  var cache = {};

  function getEl(id) {
    return document.getElementById(id);
  }

  function init() {
    var container = getEl('afw-vf');
    if (!container) return;

    var yearSelect = getEl('afw-vf-year');
    var makeSelect = getEl('afw-vf-make');
    var modelSelect = getEl('afw-vf-model');
    var searchBtn = getEl('afw-vf-search');
    var vinToggle = getEl('afw-vf-vin-toggle');
    var vinWrap = getEl('afw-vf-vin-wrap');
    var vinInput = getEl('afw-vf-vin-input');
    var vinBtn = getEl('afw-vf-vin-btn');
    var dropdownWrap = getEl('afw-vf-dropdowns');
    var resultBox = getEl('afw-vf-result');
    var loader = getEl('afw-vf-loader');

    if (!yearSelect || !makeSelect || !modelSelect) return;

    // Populate years (current year down to 1940)
    var currentYear = new Date().getFullYear() + 1; // include next model year
    for (var y = currentYear; y >= 1940; y--) {
      var opt = document.createElement('option');
      opt.value = y;
      opt.textContent = y;
      yearSelect.appendChild(opt);
    }

    // Populate makes
    COMMON_MAKES.forEach(function (make) {
      var opt = document.createElement('option');
      opt.value = make;
      opt.textContent = make;
      makeSelect.appendChild(opt);
    });

    // Year or Make change → fetch models
    yearSelect.addEventListener('change', onYearMakeChange);
    makeSelect.addEventListener('change', onYearMakeChange);

    function onYearMakeChange() {
      var year = yearSelect.value;
      var make = makeSelect.value;
      modelSelect.innerHTML = '<option value="">Select Model</option>';
      modelSelect.disabled = true;
      searchBtn.disabled = true;
      hideCustomModelInput();
      hideResult();

      if (!year || !make) return;

      fetchModels(make, year);
    }

    function fetchModels(make, year) {
      var cacheKey = make + '_' + year;
      if (cache[cacheKey]) {
        populateModels(cache[cacheKey]);
        return;
      }

      // Also check sessionStorage
      try {
        var stored = sessionStorage.getItem('afw_models_' + cacheKey);
        if (stored) {
          var parsed = JSON.parse(stored);
          cache[cacheKey] = parsed;
          populateModels(parsed);
          return;
        }
      } catch (e) { /* sessionStorage not available */ }

      showLoader();
      var url = NHTSA_BASE + '/GetModelsForMakeYear/make/' +
        encodeURIComponent(make) + '/modelyear/' + year + '?format=json';

      fetch(url)
        .then(function (res) { return res.json(); })
        .then(function (data) {
          var models = [];
          if (data.Results && data.Results.length) {
            data.Results.forEach(function (r) {
              if (r.Model_Name) {
                models.push(r.Model_Name);
              }
            });
          }
          // Sort alphabetically and deduplicate
          models = models
            .filter(function (v, i, a) { return a.indexOf(v) === i; })
            .sort();

          cache[cacheKey] = models;
          try {
            sessionStorage.setItem('afw_models_' + cacheKey, JSON.stringify(models));
          } catch (e) { /* ignore */ }

          populateModels(models);
        })
        .catch(function () {
          hideLoader();
          modelSelect.innerHTML = '<option value="">Could not load models</option>';
        });
    }

    function populateModels(models) {
      hideLoader();
      modelSelect.innerHTML = '<option value="">Select Model</option>';

      /* If API returned nothing, try classic fallback list */
      if (models.length === 0) {
        var make = makeSelect.value;
        if (CLASSIC_MODELS[make] && CLASSIC_MODELS[make].length > 0) {
          models = CLASSIC_MODELS[make];
        }
      }

      if (models.length === 0) {
        /* No API results and no classic fallback — show "Other" free-text option */
        var otherOpt = document.createElement('option');
        otherOpt.value = '__other__';
        otherOpt.textContent = 'Other — Type Your Model';
        modelSelect.appendChild(otherOpt);
        modelSelect.disabled = false;
        return;
      }

      models.forEach(function (name) {
        var opt = document.createElement('option');
        opt.value = name;
        opt.textContent = name;
        modelSelect.appendChild(opt);
      });

      /* Always add "Other" at the end for models not in the list */
      var otherOpt2 = document.createElement('option');
      otherOpt2.value = '__other__';
      otherOpt2.textContent = 'Other — Type Your Model';
      modelSelect.appendChild(otherOpt2);

      modelSelect.disabled = false;
    }

    // "Other" model — custom text input
    var customModelInput = null;

    function showCustomModelInput() {
      if (customModelInput) return; // already visible
      customModelInput = document.createElement('input');
      customModelInput.type = 'text';
      customModelInput.id = 'afw-vf-model-custom';
      customModelInput.placeholder = 'Type your model (e.g. F-150, Mustang)';
      customModelInput.className = 'afw-vf__select afw-vf__model-custom'; // reuse dropdown styling
      customModelInput.style.marginTop = '8px';
      modelSelect.parentNode.insertBefore(customModelInput, modelSelect.nextSibling);
      customModelInput.focus();

      customModelInput.addEventListener('input', function () {
        searchBtn.disabled = !customModelInput.value.trim();
      });
      customModelInput.addEventListener('keypress', function (e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          if (!searchBtn.disabled) searchBtn.click();
        }
      });
    }

    function hideCustomModelInput() {
      if (customModelInput) {
        customModelInput.parentNode.removeChild(customModelInput);
        customModelInput = null;
      }
    }

    // Model change → enable search (or show custom input)
    modelSelect.addEventListener('change', function () {
      hideResult();
      if (modelSelect.value === '__other__') {
        searchBtn.disabled = true;
        showCustomModelInput();
      } else {
        hideCustomModelInput();
        searchBtn.disabled = !modelSelect.value;
      }
    });

    // Search button
    searchBtn.addEventListener('click', function () {
      var year = yearSelect.value;
      var make = makeSelect.value;
      var model = (modelSelect.value === '__other__' && customModelInput)
        ? customModelInput.value.trim()
        : modelSelect.value;

      if (!year || !make || !model) return;

      doVehicleSearch(year, make, model);
    });

    // VIN toggle
    if (vinToggle && vinWrap) {
      vinToggle.addEventListener('click', function (e) {
        e.preventDefault();
        var isHidden = vinWrap.style.display === 'none' || !vinWrap.style.display;
        vinWrap.style.display = isHidden ? 'flex' : 'none';
        if (dropdownWrap) {
          dropdownWrap.style.display = isHidden ? 'none' : 'flex';
        }
        vinToggle.textContent = isHidden
          ? 'Or search by Year / Make / Model'
          : 'Or search by VIN';
        hideResult();
      });
    }

    // VIN lookup
    if (vinBtn && vinInput) {
      vinBtn.addEventListener('click', function () {
        var vin = vinInput.value.trim();
        if (vin.length !== 17) {
          showResult('Please enter a valid 17-character VIN.', 'error');
          return;
        }
        decodeVIN(vin);
      });

      vinInput.addEventListener('keypress', function (e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          vinBtn.click();
        }
      });
    }

    function decodeVIN(vin) {
      showLoader();
      var url = NHTSA_BASE + '/DecodeVinValues/' + encodeURIComponent(vin) + '?format=json';

      fetch(url)
        .then(function (res) { return res.json(); })
        .then(function (data) {
          hideLoader();
          if (data.Results && data.Results[0]) {
            var r = data.Results[0];
            var year = r.ModelYear;
            var make = r.Make;
            var model = r.Model;

            if (year && make && model) {
              doVehicleSearch(year, make, model);
            } else {
              showResult('Could not decode that VIN. Please try Year/Make/Model search instead.', 'error');
            }
          }
        })
        .catch(function () {
          hideLoader();
          showResult('Error looking up VIN. Please try again or use Year/Make/Model search.', 'error');
        });
    }

    function doVehicleSearch(year, make, model) {
      showLoader();

      // Save vehicle to sessionStorage for collection page filtering
      try {
        sessionStorage.setItem('afw_vehicle', JSON.stringify({
          year: year, make: make, model: model
        }));
      } catch (e) { /* ignore */ }

      // ── TAG-BASED COLLECTION FILTERING ──
      // Products are tagged with make:Ford, model:F-150, year:2020
      // Shopify natively filters: /collections/all/tag1+tag2+tag3
      // This is server-side, instant, paginated, and accurate.
      var tagParts = [
        'make:' + make,
        'model:' + model
      ];
      if (year) tagParts.push('year:' + year);
      var tagPath = tagParts.join('+');

      // Quick check: does this vehicle have tagged products?
      var checkUrl = '/collections/all/' + tagPath + '?view=json';

      // Go straight to tag-filtered collection (fast, server-side)
      window.location.href = '/collections/all/' + tagPath;
    }

    function showFallback(year, make, model) {
      var vehicle = year + ' ' + make + ' ' + model;

      // Build tag path for collection filtering
      var tagParts = ['make:' + make, 'model:' + model];
      if (year) tagParts.push('year:' + year);
      var tagPath = tagParts.join('+');

      // Determine if this is a truck/SUV make for relevant categories
      var isTruck = TRUCK_MAKES.indexOf(make) !== -1;

      var cats = [
        { icon: 'la-arrows-alt-v', label: 'Suspension', href: '/collections/suspension-lift-kits/' + tagPath },
        { icon: 'la-compress-arrows-alt', label: 'Shocks', href: '/collections/shocks-struts/' + tagPath },
        { icon: 'la-cog', label: 'Wheels', href: '/collections/wheels/' + tagPath },
        { icon: 'la-lightbulb', label: 'Lighting', href: '/collections/lighting/' + tagPath },
        { icon: 'la-car', label: 'Exterior', href: '/collections/exterior-accessories/' + tagPath },
        { icon: 'la-wind', label: 'Exhaust', href: '/collections/exhaust-systems/' + tagPath },
        { icon: 'la-link', label: 'Hitches', href: '/collections/hitches-towing/' + tagPath },
        { icon: 'la-tools', label: 'All Services', href: '/pages/all-services' }
      ];

      if (isTruck) {
        cats.splice(5, 0, { icon: 'la-shield-alt', label: 'Bumpers', href: '/collections/bumpers-protection/' + tagPath });
        cats.splice(7, 0, { icon: 'la-box', label: 'Bed Covers', href: '/collections/tonneau-covers-bed-accessories/' + tagPath });
      }

      var catHtml = '';
      cats.forEach(function (c) {
        catHtml += '<a href="' + c.href + '" class="afw-vf-cat">' +
          '<i class="las ' + c.icon + '"></i>' +
          '<span>' + c.label + '</span></a>';
      });

      var html = '<div class="afw-vf-fallback">' +
        '<h3>Shop For Your ' + escapeHtml(vehicle) + '</h3>' +
        '<p>Browse categories available for your vehicle, or let our experts help you find exactly what you need.</p>' +
        '<div class="afw-vf-cats">' + catHtml + '</div>' +
        '<div class="afw-vf-fallback__divider"></div>' +
        '<p class="afw-vf-fallback__help-label">Need help finding the right fit?</p>' +
        '<div class="afw-vf-fallback__actions">' +
        '<a href="tel:9132912027" class="afw-vf-btn afw-vf-btn--call">' +
        '<i class="las la-phone"></i> Call (913) 291-2027</a>' +
        '<a href="https://www.google.com/maps/dir/?api=1&destination=12310+W+62nd+Ter+Shawnee+KS+66216" ' +
        'target="_blank" rel="noopener" class="afw-vf-btn afw-vf-btn--visit">' +
        '<i class="las la-map-marker-alt"></i> Visit Our Shop</a>' +
        '</div>' +
        '<p class="afw-vf-fallback__address">12310 W 62nd Ter, Shawnee, KS 66216 &bull; Mon-Fri 9-6, Sat 10-4</p>' +
        '</div>';
      showResult(html, 'fallback');
    }

    function showResult(content, type) {
      if (!resultBox) return;
      resultBox.innerHTML = content;
      resultBox.className = 'afw-vf-result afw-vf-result--' + (type || 'info');
      resultBox.style.display = 'block';
    }

    function hideResult() {
      if (!resultBox) return;
      resultBox.style.display = 'none';
      resultBox.innerHTML = '';
    }

    function showLoader() {
      if (loader) loader.style.display = 'flex';
    }

    function hideLoader() {
      if (loader) loader.style.display = 'none';
    }

    function escapeHtml(str) {
      var div = document.createElement('div');
      div.appendChild(document.createTextNode(str));
      return div.innerHTML;
    }
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* ================================================
     Vehicle Context Banner
     Shows on collection/product/page pages when
     customer arrives via the vehicle finder
     ================================================ */
  function initVehicleBanner() {
    /* Suppress banner if the global vehicle bar is present */
    if (document.getElementById('afw-vbar')) return;

    var params = new URLSearchParams(window.location.search);
    var year = params.get('year');
    var make = params.get('make');
    var model = params.get('model');

    // v16: Also parse vehicle from tag-filtered collection URL path
    if (!year || !make || !model) {
      var pathMatch = window.location.pathname.match(/\/collections\/[^/]+\/(.+)/);
      if (pathMatch) {
        var tagStr = decodeURIComponent(pathMatch[1]);
        var tags = tagStr.split('+');
        tags.forEach(function(t) {
          var val = t.split(':').slice(1).join(':');
          if (t.indexOf('year:') === 0 && !year) year = val;
          else if (t.indexOf('make:') === 0 && !make) make = val;
          else if (t.indexOf('model:') === 0 && !model) model = val;
        });
      }
    }

    // Save to sessionStorage if params present
    if (year && make && model) {
      try {
        sessionStorage.setItem('afw_vehicle', JSON.stringify({
          year: year, make: make, model: model
        }));
      } catch (e) { /* ignore */ }
    } else {
      // Try to load from sessionStorage
      try {
        var stored = sessionStorage.getItem('afw_vehicle');
        if (stored) {
          var v = JSON.parse(stored);
          year = v.year;
          make = v.make;
          model = v.model;
        }
      } catch (e) { /* ignore */ }
    }

    if (!year || !make || !model) return;

    // Don't show on the homepage (vehicle finder is already there)
    if (window.location.pathname === '/') return;

    var vehicle = year + ' ' + make + ' ' + model;

    // On collection pages, add a "Filter for your vehicle" link using tag-based filtering
    var isCollection = window.location.pathname.indexOf('/collections/') === 0;
    var searchLink = '';
    if (isCollection) {
      // v16: Check if we're already on a tag-filtered page
      var alreadyFiltered = window.location.pathname.indexOf('make:') !== -1;
      if (!alreadyFiltered) {
        var pathParts = window.location.pathname.split('/');
        var collHandle = (pathParts[2] || 'all').split('/')[0]; // strip any existing tags
        var tagParts = ['make:' + make, 'model:' + model];
        if (year) tagParts.push('year:' + year);
        var tagPath = tagParts.join('+');
        searchLink = '<a href="/collections/' + collHandle + '/' + tagPath +
          '" class="afw-vehicle-banner__search">' +
          '<i class="las la-filter"></i> Filter for your ' + escBanner(make + ' ' + model) + '</a>';
      }
    }

    // Build the banner
    var banner = document.createElement('div');
    banner.className = 'afw-vehicle-banner';
    banner.innerHTML =
      '<div class="afw-vehicle-banner__inner">' +
        '<i class="las la-car"></i>' +
        '<span class="afw-vehicle-banner__text">Shopping for your <strong>' +
          escBanner(vehicle) + '</strong></span>' +
        searchLink +
        '<a href="/?scroll=vf#afw-vf" class="afw-vehicle-banner__change">Change Vehicle</a>' +
        '<button class="afw-vehicle-banner__close" aria-label="Close">&times;</button>' +
      '</div>';

    // Insert at top of main content area
    var main = document.querySelector('main') || document.querySelector('#MainContent') ||
      document.querySelector('.t4s-main-content') || document.body;

    if (main && main.firstChild) {
      main.insertBefore(banner, main.firstChild);
    } else if (main) {
      main.appendChild(banner);
    }

    // Close button
    var closeBtn = banner.querySelector('.afw-vehicle-banner__close');
    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        banner.style.display = 'none';
        try { sessionStorage.removeItem('afw_vehicle'); } catch (e) { /* ignore */ }
      });
    }
  }

  function escBanner(str) {
    var d = document.createElement('div');
    d.appendChild(document.createTextNode(str));
    return d.innerHTML;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initVehicleBanner);
  } else {
    initVehicleBanner();
  }
})();
